import alt from '../alt'
import MessageActions from '../actions/MessageActions'

class MessageStore {
  constructor () {
    this.bindActions(MessageActions)
    this.messages = []
  }

  onFetchedMessages (messages) {
    this.messages = messages
  }

}

export default alt.createStore(MessageStore, 'MessageStore')
